import { Product } from './models/Product';

/** Prefer the main supplier link; otherwise the first linked supplier. */
export function getMainSupplierIdForProduct(product: Product): string | undefined {
  const links = product.supplierLinks;
  if (!links?.length) return undefined;
  const main = links.find(l => l.isMain);
  return (main ?? links[0]).supplierId;
}
